import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { LegalDocs } from '@srca-b2b/kp5-ui-common'
import Layout from 'components/Layout/Layout'
import UspPageTitle from 'components/UspPageTitle/UspPageTitle'
import { getLegalDocsServer, getLegalDocsVersion } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import { useRouter } from 'next/router'

const title = 'Samsung Data Processing Agreement'
const legalType = 'kcs_data_processing_agreement'

const LegalAgreement = ({ legalDocsResponse, legalDocsVersions }) => {
  const router = useRouter()
  return (
    <Layout id={legalType} title={`${title} | Knox Partner Program`}>
      <UspPageTitle title="Legal" />
      <Container>
        <Row>
          <Col sm={12}>
            <LegalDocs
              title={title}
              agreements={legalDocsResponse.data}
              legalVersions={legalDocsVersions.data[0].versions}
              initialVersion={router?.query?.v || null}
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps() {
  const legalDocsResponse = await getLegalDocsServer([legalType])
  const legalDocsVersions = await getLegalDocsVersion(legalType)
  if (legalDocsResponse.statusCode !== 200 || legalDocsVersions.statusCode !== 200) {
    return {
      redirect: {
        destination: '/en/404',
        permanent: false
      }
    }
  }
  return {
    props: { legalDocsResponse, legalDocsVersions }
  }
}

export default LegalAgreement
